import type { Merge, SetRequired } from 'type-fest';
import type { StringOrNullableString } from '../../../../../../react-commons/components/inputs/controlled/types';
import { useField } from '../../../../../../react-commons/hooks/useField';
import type { ExtractAllEnumKeys } from '../../../../../../react-commons/types/extractKeysOfType';
import {
    Controlled_AutocompleteResourceTextField,
    type Controlled_AutocompleteResourceTextFieldProps,
} from './Controlled_AutocompleteResourceTextField';

export type Form_AutocompleteResourceTextFieldProps<
    T extends object,
    R extends { id: string | null; objectId?: string | null } & Record<string, unknown>,
    TTypeKey extends keyof R & ExtractAllEnumKeys<R>,
    TNullable extends boolean,
> = Merge<
    Omit<
        SetRequired<Controlled_AutocompleteResourceTextFieldProps<R, TTypeKey, TNullable>, 'nullable'>,
        keyof useField.Result<StringOrNullableString<TNullable>>
    >,
    useField.Props<StringOrNullableString<TNullable>, T>
>;

export const Form_AutocompleteResourceTextField = <
    T extends object,
    R extends { id: string | null; objectId?: string | null } & Record<string, unknown>,
    TTypeKey extends keyof R & ExtractAllEnumKeys<R>,
    TNullable extends boolean,
>({
      name,
      control,
      onChange,
      ...props
  }: Form_AutocompleteResourceTextFieldProps<T, R, TTypeKey, TNullable>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return <Controlled_AutocompleteResourceTextField {...props} {...fieldProps} />;
};
